import { Component, OnInit } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { TopicService } from '..//topic.service';
import { ActivatedRoute } from '@angular/router';
import { SelfcorrectingService } from '../selfcorrecting.service';

@Component({
  selector: 'app-t-intuitive',
  templateUrl: './t-intuitive.component.html',
  styleUrls: ['./t-intuitive.component.css']
})
export class TIntuitiveComponent extends GeneralTeacherComponent {

  cloe: string;
  variations: string[];

  errorCount: number;
  countPossibleAnswers: number;

  constructor(topicService: TopicService, activatedRoute: ActivatedRoute, protected selfcorrectingService: SelfcorrectingService) {
    super(topicService, activatedRoute);
    this.type = "intuitive"
    this.title = this.get("intuitive");
    this.cloe = "";
    for (let i = 0; i < 5; i++) {
      this.cloe = this.cloe.concat((Math.random() > 0.5 ? "0" : "1"));
    }
    if (this.cloe == "00000" || this.cloe == "11111") {
      this.cloe = "10111";
    }
  }

  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.cloe = this.configuration.typespecifics.cloe;
    this.variations = this.configuration.typespecifics.variations;
    this.errorCount = this.configuration.typespecifics.errorCount;
    this.countPossibleAnswers = this.variations.filter(v => this.selfcorrectingService.distance(v, this.cloe) <= this.errorCount).length;
  }

  generateDefinition() {
    let definition: any = {};
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = "./assets/images/intuitive.png";
    definition.level = 1;
    definition.key = "selfcorrecting%".concat(this.type, "%");
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.typespecifics = {};
    definition.typespecifics.cloe = this.cloe;
    definition.typespecifics.variations = this.variations;
    definition.typespecifics.errorCount = this.errorCount;
    definition.key = definition.key.concat("%", this.cloe, "%", this.variations.toString(), "%", this.errorCount.toString());

    return definition;
  }

  generate(){
    this.errorCount = Math.random() > 0.5 ? 1 : 2;
    this.countPossibleAnswers = Math.floor(Math.random() * 4);
    this.onChange();
  }

  /** copmutes the variationes */
  onChange() {
    if (this.errorCount != undefined && this.countPossibleAnswers != undefined) {
      let correctAnswers = this.selfcorrectingService.distanceSmallerEqual(5, this.errorCount, this.cloe);
      let wrongAnswers = this.selfcorrectingService.distanceLarger(5, this.errorCount, this.cloe);

      this.variations = [];
      for (let i = 0; i < this.countPossibleAnswers; i++) {
        this.variations.push(correctAnswers.splice(Math.floor(Math.random() * correctAnswers.length), 1)[0]);
      }
      for (let i = 0; i < 4 - this.countPossibleAnswers; i++) {
        this.variations.push(wrongAnswers.splice(Math.floor(Math.random() * wrongAnswers.length), 1)[0]);
      }
      this.shuffleArray(this.variations);
    }
  }

  /** randomly permutes a given array */
  shuffleArray(array) {
    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
  }

  reset(){
    super.reset();
    this.title = this.get("intuitive");
    this.errorCount = undefined;
    this.countPossibleAnswers= undefined;
    this.cloe = "";
    for (let i = 0; i < 5; i++) {
      this.cloe = this.cloe.concat((Math.random() > 0.5 ? "0" : "1"));
    }
    if (this.cloe == "00000" || this.cloe == "11111") {
      this.cloe = "10111";
    }
  }

}
